import { render, staticRenderFns } from "./CaseDashboard.vue?vue&type=template&id=058b24aa&scoped=true&"
import script from "./CaseDashboard.vue?vue&type=script&lang=js&"
export * from "./CaseDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CaseDashboard.vue?vue&type=style&index=0&id=058b24aa&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b24aa",
  null
  
)

export default component.exports